export enum AccessRole {
  GENERAL = 0,
  ADMIN = 3,
  SUPER_ADMIN = 2,
}

export enum AccessType {
  FLIGHT_REQUEST_READ,
  FLIGHT_REQUEST_CREATE,
  FLIGHT_REQUEST_UPDATE,
  FLIGHT_REQUEST_DUPLICATE,
  FLIGHT_REQUEST_CANCEL,
  FLIGHT_REQUEST_UPLOAD,
  FLIGHT_REQUEST_UPDATE_COST,

  FLIGHT_REQUEST_RISK_ASSESSMENT,

  FIRE_DISPATCH_READ,

  NOTIFICATION_READ,

  ADMIN_READ,

  ROLE_MANAGER_READ,
  SETTING_READ,
}

export const AccessPermission = {
  [AccessRole.GENERAL]: [
    AccessType.FLIGHT_REQUEST_READ,
    AccessType.FLIGHT_REQUEST_CREATE,
    AccessType.FLIGHT_REQUEST_UPLOAD,
    AccessType.FLIGHT_REQUEST_CANCEL,
    AccessType.FLIGHT_REQUEST_DUPLICATE,
  ],

  [AccessRole.SUPER_ADMIN]: [
    AccessType.ROLE_MANAGER_READ,
    AccessType.SETTING_READ,
  ],
};
